export default [
    {
        path: "/elibrary",
        name: "elibrary",
        component: () => import("@/pages/elibrary/Elibrary.vue"),
        meta: {
            pageTitle: "E-Library",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "guest",
            // resource: "pelatihan",
            action: "read",
        },
    },
];
